export const styles = {
  profileContainer: {
    padding: '20px 35px 20px 40px',
    height: 'calc(100vh - 72px)',
    backgroundColor: '#F9F9FF',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },

  breadcrumbsWrapper: {
    marginBottom: '24px',
  },

  profileContent: {
    display: 'flex',
    flexDirection: 'column',
    width: '1100px',
    minHeight: '340px',
    margin: '30px 0',
    fontSize: '16px',
    backgroundColor: '#FFFFFF',
    padding: '30px 50px 30px 30px',
    borderRadius: '8px',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
  },
  profileTitle: {
    display: 'flex',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    fontSize: '32px',
    fontWeight: '800',
    margin: '18px 0 30px 0',
  },

  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '345px',
    width: '100%',
    height: '100%',
  },

  link: {
    display: 'flex',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },

  icon: {
    marginRight: '10px',
    width: 20,
    height: 20,
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: '12px',
  },
}
